/**
 * SelectionTooltip — Floating "Add comment" icon on text selection.
 *
 * Positioned above the selected text using screen coordinates from
 * useTextSelection. Clicking opens the comment margin with the
 * selection anchored.
 *
 * See: docs/features/document-system/document-comments.md (Phase 7)
 */
import React from "react";
import { MessageSquarePlus } from "lucide-react";

const SelectionTooltip = ({ selection, onAddComment }) => {
  if (!selection?.coords) return null;

  const style = {
    position: "fixed",
    top: selection.coords.top - 36,
    left: selection.coords.left,
    transform: "translateX(-50%)",
    zIndex: 200,
  };

  return (
    <div className="selection-tooltip" style={style}>
      <button
        className="selection-tooltip-btn"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          onAddComment(selection);
        }}
        aria-label="Add comment to selection"
        onMouseDown={(e) => e.preventDefault()}
      >
        <MessageSquarePlus size={14} />
      </button>
    </div>
  );
};

export default React.memo(SelectionTooltip);
